<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">缴费记录查询</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="车牌号" prop="CarNo">
            <el-input v-model="CarNo" placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="缴费时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:60rem;"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="PlateNo" label="车牌号"></el-table-column>
              <el-table-column prop="ParkName" label="停车场"></el-table-column>
              <el-table-column prop="VehicleType" label="车辆类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.VehicleType == 0">其他车</span>
                  <span v-else-if="scope.row.VehicleType == 1">小型车</span>
                  <span v-else-if="scope.row.VehicleType == 2">大型车</span>
                  <span v-else-if="scope.row.VehicleType == 3">摩托车</span>
                  <span v-else>未知</span>
                </template>
              </el-table-column>
              <el-table-column prop="ReceivableMoney" label="缴费金额"></el-table-column>
              <el-table-column prop="payTime" label="缴费时间" width="140" :formatter="formatDate"></el-table-column>
              <el-table-column prop="PaymentType" label="缴费方式"></el-table-column>
              <el-table-column prop="ParkTime" label="停留时长（分钟）"></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "CarParkFeeRecordView",
  controller: "UI",
  action: "CarParkFeeRecordView",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CarNo: "",
      date: [new Date(), new Date()]
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        platNo: this.CarNo,
        payStartTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 0:00"),
        payEndTime:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59"),
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      new MyApis.CarParkFeeApi()
        .GetItemPagingList(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarNo = "";
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>
